import {ValueListener} from "./interfaces";
import {config} from "../config";
import {ServiceApi} from "../serviceApi";

export const checkForPrivateEvents = (eventDataSource: any, listener: ValueListener<boolean>) => {
  listener = eventDataSource.wrapListener(listener);

  let hasPrivateEvents;

  const onUpdate = function () {
    listener.onValue(hasPrivateEvents);
  };

  const compute = function () {
  const api = new ServiceApi(config.joyServiceConfig);
  api.queryGraphQLWithErrors(`
    query {
      event(eventId: "${eventDataSource.getEvent().eventId}") {
        info {
          schedule {
            hasPrivateEvents
            }
          }
        }
      }
    `).then(response => {
        hasPrivateEvents = response.event.info.schedule.hasPrivateEvents;
        onUpdate();
      });
  }

  compute();
};